import Component from '@glimmer/component';
import { service } from '@ember/service';
import { LinkTo } from '@ember/routing';
import { t } from 'ember-intl';
import ApprovalPage from 'tio-common/components/tas/approval/approval-page';
import TioAppearance from 'tio-common/components/tio/appearance';
import Chip from 'tio-reimagined/components/chip';
import ENV from 'tio-employee/config/environment';
import type TasApplicationModel from 'tio-common/models/tas-application';
import type { ISession } from 'tio-common/types/services';

interface RouteSignature {
  Args: {
    model: TasApplicationModel;
  };
}

export default class TuitionAssistanceApplicationsShowApprovalRoute extends Component<RouteSignature> {
  @service declare session: ISession;

  <template>
    <ApprovalPage @model={{@model}}>
      <:header>
        <div class="flex justify-between items-start">
          <div class="flex flex-col gap-3">
            <div class="flex items-center gap-2">
              <h1 class="text-lg font-semibold text-gray-700">
                {{t "tas.approval.application_number"}}
                #{{@model.id}}
              </h1>
              <Chip @appearance="outlined" @intent={{@model.badgeIntent}} @size="sm">
                {{@model.badgeLabel}}
              </Chip>
              {{#if @model.hasWaiverApplied}}
                <Chip @appearance="outlined" @intent="warning" @size="sm">
                  {{t "tas.approval.waiver_applied"}}
                </Chip>
              {{/if}}
            </div>
            <div class="flex items-center gap-1.5 text-sm text-gray-500">
              <LinkTo
                @route="authenticated.admin.employees.show"
                @model={{@model.tasProgramInstance.employee.id}}
                class="font-semibold cursor-pointer"
              >
                {{@model.tasProgramInstance.employee.person.fullName}}
              </LinkTo>
              <div class="w-1 h-1 bg-gray-400 dark:bg-gray-600 rounded-full"></div>
              <span class="font-semibold">{{t "tas.approval.payroll_id_label"}}
                {{@model.tasProgramInstance.employee.payrollId}}</span>
            </div>
          </div>
          <div class="flex flex-col items-end gap-2">
            {{#if @model.id}}
              <LinkTo
                @route="authenticated.admin.tuition-assistance.applications.show"
                @model={{@model.id}}
                class="tio-btn tio-btn-default tio-btn-outlined"
                data-test-classic-view-button
              >
                {{t "common.tas_approval_queue.view"}}
              </LinkTo>
            {{/if}}
            {{! Who's Viewing }}
            {{#if @model.id}}
              <TioAppearance
                @apiKey={{ENV.apiKey}}
                @apiHost={{ENV.apiHost}}
                @token={{this.session.data.authenticated.access_token}}
                @type="tas_course_application"
                @documentId={{@model.id}}
              />
            {{/if}}
          </div>
        </div>
      </:header>
    </ApprovalPage>
  </template>
}
